import { Stack } from '@mui/material'
import { AppConnectionCardBlockCard } from './AppConnectionCardBlockCard'

export function AppConnectionCardBlockMain({ model, iconUrl, status, tags }) {
  return (
    <Stack spacing={1.5} sx={{ width: '100%', maxWidth: '100%', alignItems: 'stretch' }}>
      <AppConnectionCardBlockCard
        safeTitle={model.safeTitle}
        iconUrl={iconUrl}
        status={status}
        tags={tags}
        showConnectedChrome={model.showConnectedChrome}
        statusLabel={model.statusLabel}
        chipColor={model.chipColor}
      />
    </Stack>
  )
}
